export class CountSubscriptionResponse {
	subscriptionId: string;
	[countName: string]: number | string;
}